import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";
import { REVIEWS, BUSINESS } from "@/lib/siteData";

export default function Reviews() {
  return (
    <section id="reviews" className="relative bg-coal/70 py-24 md:py-36" data-testid="reviews-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-brass">/ Word On The Street</span>
            <h2 className="mt-5 font-display uppercase leading-[0.9] tracking-tighter text-5xl md:text-7xl">
              Treated Like <br /><span className="text-oxblood">Family</span>
            </h2>
          </div>
          <div className="flex items-center gap-4 border border-steel px-6 py-4">
            <span className="font-display text-5xl text-brass leading-none">{BUSINESS.rating}</span>
            <div>
              <div className="flex text-brass">
                {[...Array(4)].map((_, i) => <Star key={i} size={15} weight="fill" />)}
                <Star size={15} weight="fill" className="opacity-40" />
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-bone/50">
                {BUSINESS.reviewCount} reviews on Yelp
              </span>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              data-testid={`review-${i}`}
              className="relative border border-steel bg-ink p-8 flex flex-col hover:border-brass transition-colors duration-300"
            >
              <Quotes size={34} weight="fill" className="text-oxblood mb-4" />
              <div className="flex text-brass mb-4">
                {[...Array(r.stars)].map((_, s) => <Star key={s} size={14} weight="fill" />)}
              </div>
              <p className="font-body text-bone/80 leading-relaxed flex-1">{r.text}</p>
              <footer className="mt-6 pt-4 border-t border-steel">
                <div className="font-display uppercase text-lg tracking-tight text-bone">{r.name}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.15em] text-bone/45">{r.loc}</div>
              </footer>
            </motion.blockquote>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href={BUSINESS.yelp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-yelp-link"
            className="inline-block font-mono text-xs uppercase tracking-[0.2em] border border-steel text-bone px-8 py-4 hover:border-brass hover:text-brass transition-colors duration-200"
          >
            Read All Reviews On Yelp →
          </a>
        </div>
      </div>
    </section>
  );
}
